import { CsvMapper } from '@acme/core'
import dayjs from 'dayjs'
import { useState } from 'react'
import { Funcionario, funcionario as api } from 'service/api'
import * as XLSX from 'xlsx'

class FuncionarioMapper extends CsvMapper<Partial<Funcionario>> {}

export function ExportarService() {
    const [isCarregando, setIsCarregando] = useState<boolean>(false)

    function handleExportarXls(funcionarios: Funcionario[] | undefined) {
        if (!funcionarios) return
        setIsCarregando(true)
        const data = [
            [
                'Matrícula',
                'Nome do funcionário',
                'Cargo/Função',
                'PIS/PASEP',
                'CPF',
                'Data de admissão',
            ],
            ...funcionarios.map(funcionario => [
                funcionario.matricula,
                funcionario.nome,
                funcionario.funcao,
                funcionario.pis,
                funcionario.cpf,
                funcionario.dtAdmissao
                    ? dayjs(funcionario.dtAdmissao).format('DD/MM/YYYY')
                    : '',
            ]),
        ]
        const ws = XLSX.utils.aoa_to_sheet(data)

        ws['!cols'] = [
            { wpx: 60 },
            { wpx: 200 },
            { wpx: 75 },
            { wpx: 80 },
            { wpx: 80 },
            { wpx: 100 },
        ]

        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'sheet1')
        XLSX.writeFile(wb, 'exportacao_funcionarios.xlsx')
        setIsCarregando(false)
    }

    function handleExportarCsv(funcionarios: Funcionario[] | undefined) {
        if (!funcionarios) return
        setIsCarregando(true)

        new FuncionarioMapper(
            funcionarios.map(fun => ({
                matricula: fun.matricula,
                nome: fun.nome,
                funcao: fun.funcao,
                pis: fun.pis,
                cpf: fun.cpf,
                dtAdmissao: fun.dtAdmissao,
            })),
        ).downloadCsv('exportacao-funcionarios')
        setIsCarregando(false)
    }

    async function handleExportarFicha(
        funcionario: Funcionario,
        tipo: 'pdf' | 'csv' | 'xls',
    ) {
        if (!funcionario) return
        setIsCarregando(true)

        if (tipo === 'csv' || tipo === 'xls') {
            new FuncionarioMapper([funcionario]).downloadCsv(
                'ficha-funcionario',
            )
        } else if (tipo === 'pdf') {
            await api.ficha
                .pdf({
                    data: funcionario,
                })
                .finally(() => setIsCarregando(false))
        }
        setIsCarregando(false)
    }

    async function handleExportarPdf(
        funcionarios: Array<Funcionario> | undefined,
    ) {
        if (!funcionarios?.length) return
        setIsCarregando(true)
        await api.relatorio
            .pdf({
                data: funcionarios.map(({ id }) => id),
                queryParam: {
                    empresaId: funcionarios[0].empresaId,
                },
            })
            .finally(() => setIsCarregando(false))
    }

    return {
        handleExportarXls,
        handleExportarPdf,
        handleExportarCsv,
        handleExportarFicha,
        isCarregando,
    }
}
